import React, {FC, ImgHTMLAttributes} from "react";
import logoFull from '../../../../assets/images/svg/conomica-loans.svg';
import logoHeader from '../../../../assets/images/svg/conomica-loans-header.svg';
import cone from '../../../../assets/images/svg/cone.svg';
import Image from "../Image";

// Фирменные файлы «Conomica займы» — те же и с теми же именами, что в лендинге группы.
export enum LogoType {
    // мастер-логотип: там, где логотип — главный элемент (вход, футер)
    FULL = logoFull,
    // логотип, нарисованный для шапки
    HEADER = logoHeader,
    // одна шишка — там, где логотип целиком не помещается
    CONE = cone,
}

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
    type: LogoType
}

const LogoImage: FC<Props> = ({type, ...props}) => {
  return (
    <Image {...props} src={type.toString()} alt={"Conomica займы"} />
  );
};

export default LogoImage;
